declare const require: (path: string) => string;

export const slides = [
  {
    title: '',
    description: ``,
    stats: [
    ],
    image: '',
    image2x: ''
  },
  {
    title: 'Уникальный формат',
    description: `Пентхаус на вершине небоскреба - не просто квартира, а подтверждение статуса владельца и его высоких требований к качеству жизни. Собственная просторная панорамная терраса  – эксклюзив даже  среди недвижимости премиум-класса. Сочетание этих преимуществ и исключительной для небоскребов локации – тихого, зеленого района в престижном западном округе – это пентхаусы в ЖК НЕБО, по-настоящему уникальное предложение недвижимости Москвы.`,
    stats: [
    ],
    image: require('../static/images/1x/2.jpg'),
    image2x: require('../static/images/2x/2.jpg')
  },
  {
    title: 'Террасы с лучшими видами Москвы',
    description: `В каждом пентхаусе – просторная терраса с захватывающими дух видами. Величественная высотка МГУ или урбанистическая красота «Москвы-Сити» – будущие резиденты могут выбрать видовую доминанту на свой вкус. Неизменно одно – панорама города до самого горизонта и высокое, бескрайнее небо.`,
    stats: [
    ],
    image: require('../static/images/1x/3.jpg'),
    image2x: require('../static/images/2x/3.jpg')
  },
  {
    title: 'Ограниченное предложение',
    description: `Всего 12 пентхаусов, не имеющих аналогов в локации – первые и единственные на Мичуринском проспекте, расположенные на последних этажах небоскребов, за облаками. Уникальные характеристики позволяют будущим резидентам выбрать по-настоящему эксклюзивный формат в московском бизнес-классе на принципиально новой высоте.`,
    stats: [
    ],
    image: require('../static/images/1x/4.jpg'),
    image2x: require('../static/images/2x/4.jpg')
  },
  {
    title: 'Двухуровневые квартиры',
    description: `Все пентхаусы – двухуровневые. Это планировочное решение позволяет не ограничивать себя в зонировании пространства и использовать все преимущества формата. Лестница может стать четкой границей между гостевой и приватной зонами, а может – центральным акцентом интерьера, приглашающим гостей подняться на второй уровень, к террасе для отдыха. Большая площадь позволяет адаптировать ее под любые нужды: поставить джакузи, оборудовать пати-зону с открытым камином или собственный тренажерный зал на открытом воздухе.`,
    stats: [
      
    ],
    image: require('../static/images/1x/5.jpg'),
    image2x: require('../static/images/2x/5.jpg')
  },
  {
    title: 'Свободные планировки',
    description: `У всех пентхаусов – свободные планировки, что оставляет будущим резидентам творческий простор для создания квартиры мечты, идеально соответствующей их характеру и образу жизни.`,
    stats: [
    ],
    image: require('../static/images/1x/6.jpg'),
    image2x: require('../static/images/1x/6.jpg')
  },
]